import {LangKey} from "../globalContext";
import {useEffect, useState} from "react";

export function useI18nText(allLang: LangKey[], lang: LangKey) {
    const [langs, setLangs] = useState<LangKey[]>(["RU"]);
    const [isActive, setIsActive] = useState<boolean>(false)

    // Callers routinely pass a fresh array literal (`props.allLang || []`), so
    // allLang changes identity on every render and this effect re-runs every
    // render. Returning the previous array when the contents are unchanged lets
    // React bail out; setting a new array unconditionally re-renders forever.
    useEffect(() => {
        const next = Array.from(new Set([lang, ...allLang]))
        setLangs((prev) => (
            prev.length === next.length && prev.every((l, i) => l === next[i]) ? prev : next
        ))
    }, [lang, allLang])

    return {
        langs,
        isActive,
        setIsActive,
    }
}